module.exports = __webpack_public_path__ + "components/flag/static/square/tm-b1363a6bfb28b8d77545aa19fcd92fcc.svg";